import { SyntheticEvent, useCallback } from 'react';

import useRevokeQuery from '@/modules/core/queries/useRevoke.query';
import { removeStoredClaimsResponses } from '@/modules/employer/components/Claims/queries/useClaimsList.query';
import { stopDataDogSession } from '@/utils/config';
import Token, { IS_SSO_TOKEN } from '@/utils/handlers/Token';

import { useAuthStore } from '../stores';

import useAwsAmplifyLogout from './useAwsAmplifyLogout';

// const NEW_PASSWORD_TOKEN_KEY = 'NEW_PASSWORD_REQUIRED';
export const NEW_PASSWORD_TOKEN_KEY = 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED';

const useAuthorization = () => {
  const store = useAuthStore();
  const { awsAmplifyLogout } = useAwsAmplifyLogout();
  const { handleRevoke } = useRevokeQuery();

  const handleLogout = useCallback(async (onSSOLogout?: (() => void) | SyntheticEvent) => {
    const isSsoLogin = localStorage.getItem(IS_SSO_TOKEN);
    removeStoredClaimsResponses();
    const refreshToken = Token.getRefreshToken();
    await handleRevoke({ refresh_token: refreshToken });
    // Close the RUM session while the user is still attached to it.
    stopDataDogSession();
    Token.clear();
    store.setAuth(false);
    store.setContactId();
    store.setOrganizationId();
    store.setUser(null);

    if (isSsoLogin) {
      if (typeof onSSOLogout === 'function') {
        onSSOLogout();
      }
      awsAmplifyLogout();
    } else {
      location.reload();
      // fix issue when we switch users with different role
      location.replace('/');    
    }
  }, [store, awsAmplifyLogout, handleRevoke]);

  return {
    handleLogout,
  };
};

export default useAuthorization;
